import React, { useContext, useState, useEffect } from 'react';

import { PagePropsContext } from '../App';
import { getRootCategoryId } from '../utils/functions';

const CategoryList = () => {
  const { categories, selectedCategory, setSelectedCategory } = useContext(PagePropsContext);

  const [children, setChildren] = useState([]);

  useEffect(() => {
    const rootId = getRootCategoryId(categories, selectedCategory.id);
    setChildren(categories.filter(cat => cat.parent_category === rootId));
  }, [categories, selectedCategory]);

  return <ul className='category-list'>
    {children.map(cat => <li
      key={cat.id}
      className={'category-list__item' + (cat.id === selectedCategory.id ? ' item--active' : '')}
      onClick={() => setSelectedCategory(cat)}>
      {cat.name}
    </li>)}
  </ul>;
}

export default CategoryList;